// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"38880":"db42615081ed9b4f","41489":"ff02a7fea42ce639","83545":"18e7aa7a61939fa1"}[chunkId] + ".css";
};